module.exports = __webpack_public_path__ + "static/media/earthdna_logo.d58f1c69.png";